import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ChunkNotFoundDialogService {
    readonly visible = signal(false);
}
